import {Injectable} from '@angular/core';

@Injectable()
export class CurrentModuleService {
    private moduleName: string;

    public static readonly "CURRENT_MODULE_TYPE_NEUTRAL": string = "cycleNeutral";

    constructor() {
    }

    public setModuleName(moduleName) {
        this.moduleName = moduleName;
    }

    public getModuleName(): string {
        return this.moduleName;
    }

    public getModuleNameWithSlash(): string {
        return this.moduleName + "/";
    }
}